export const validateMandatory = ({
  mandatory,
  input,
}: {
  mandatory: boolean;
  input: HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement | null;
}): boolean => {
  if (!input) return !mandatory;
  if (mandatory) {
    if (input.type === 'checkbox' || input.type === 'radio') {
      return (input as HTMLInputElement).checked;
    } else {
      return input.value != null && input.value !== '';
    }
  }
  return true;
};

export const validateAtLeastOneChecked = ({
  mandatory,
  inputs,
}: {
  mandatory: boolean;
  inputs: HTMLInputElement[];
}): boolean => {
  if (mandatory) {
    return inputs.some((input) => input.checked);
  }
  return true;
};

const minDate = (min: number) => {
  const d = new Date();
  d.setDate(d.getDate() - min);
  d.setHours(0, 0, 0, 0);
  return d;
};

const maxDate = (max: number) => {
  const d = new Date();
  d.setDate(d.getDate() + max);
  d.setHours(0, 0, 0, 0);
  return d;
};

export const validateMinMaxDate = ({
  date,
  min,
  max,
}: {
  date: Date;
  min: number;
  max: number;
}): boolean => {
  let valid = true;

  if (min != null) {
    valid &&= date >= minDate(min);
  }
  if (max != null) {
    valid &&= date <= maxDate(max);
  }
  return valid;
};
export const validateRegex = ({
  regex,
  input,
}: {
  regex: string;
  input: HTMLInputElement | HTMLTextAreaElement;
}): boolean => {
  if (regex && input.value) {
    return new RegExp(regex).test(input.value);
  }
  return true;
};
